import { render, staticRenderFns } from "./dailydeals.vue?vue&type=template&id=61968e34&scoped=true&"
import script from "./dailydeals.vue?vue&type=script&lang=js&"
export * from "./dailydeals.vue?vue&type=script&lang=js&"
import style0 from "./dailydeals.vue?vue&type=style&index=0&id=61968e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61968e34",
  null
  
)

component.options.__file = "dailydeals.vue"
export default component.exports